<div class="store-flex-wrapper">
  <ng-container> 
      <app-header></app-header>
  </ng-container>
  <app-notification></app-notification>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
